import { Outlet } from 'react-router-dom';
import { AppProvider } from '../../providers/AppContext';
import { AuthProvider } from '../../providers/logincontext';

const BaseLayout = () => (
  <AppProvider>
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  </AppProvider>
);

export default BaseLayout;
